import { BooleanEnum } from "graphql/__generated__/graphql";

export const BOOLEAN_LABEL = [
  { value: BooleanEnum.True, label: "Oui" },
  { value: BooleanEnum.False, label: "Non" },
];
